// Constantes/helpers de workflow de petición (extraído de PeticionDetail.jsx · refactor mecánico)
// Estados de LÍNEA que el usuario puede seleccionar manualmente (Flujo v2 — Fernando 31/05/26)
export const ESTADOS_LINEA_MANUALES = ["pendiente", "cancelada"];

// Transiciones de workflow (espejo de backend/workflow.py)
export const TRANSICIONES = {
  pendiente_diseno:       ["en_diseno", "cancelado"],
  en_diseno:              ["aaff_pendiente_cliente", "aaff_recibido", "cancelado"],
  aaff_pendiente_cliente: ["aaff_recibido", "cancelado"],
  aaff_recibido:          ["en_produccion", "cancelado"],
  en_produccion:          ["producido", "cancelado"],
  producido:              ["en_logistica"],
  pendiente_proveedor:    ["recibido_almacen", "recibido_pdv", "cancelado"],
  recibido_almacen:       ["en_logistica"],
  recibido_pdv:           ["en_logistica"],
  cliente_aporta:         ["en_logistica"],
  en_logistica:           ["entregado"],
  entregado:              [],
  cancelado:              [],
  pendiente:              ["pendiente_diseno", "en_diseno", "pendiente_proveedor", "cancelado"],
};

export const ETIQUETA_ESTADOS = new Set(["producido", "recibido_almacen"]);

export function abrirEtiqueta(componenteId, format = "pdf") {
  const token = localStorage.getItem("dnf_access_token");
  // Abrir nueva pestaña con bearer en query (workaround para abrir PDF inline)
  // Mejor: usar fetch + blob URL
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/componentes/${componenteId}/etiqueta.${format}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((r) => r.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener,noreferrer");
    });
}

// Sep-2026 · detección de PRODUCCIÓN por tipos[] (multi) o tipo legacy — misma lista que NuevoComponenteDialog
export const TIPOS_CON_PRODUCCION = ["produccion", "produccion_montaje", "diseno_produccion_montaje", "diseno_produccion", "produccion_envio", "diseno_produccion_envio"];
export const lineaIncluyeProduccion = (l) => {
  const tipos = Array.isArray(l?.tipos) && l.tipos.length > 0 ? l.tipos : (l?.tipo ? [l.tipo] : []);
  return tipos.some((t) => TIPOS_CON_PRODUCCION.includes(t));
};
